<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/yiiPVB/tc-custom/9781625851741.jpg?1697124110400" alt="This image is the cover for the book Haunted Inns and Ghostly Getaways of Vermont, Haunted America"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Haunted Inns and Ghostly Getaways of Vermont, Haunted America
      </h1>
      <p class="bookDescription body article font2">
        <b>Prepare to be disturbed by the preternatural guests at the Green Mountain State’s most creeptastic lodgings—from the author of <i>Haunted Burlington</i>.</b><br/>  <br/> Creaks and groans in the night remind guests that they might not be alone in Vermont’s inns. Discover the history behind some of the Green Mountain State’s spookiest places to spend the night. Loyal guest Mary Todd Lincoln enjoyed her annual respites at the Equinox Hotel in Manchester so much that death could not interrupt the tradition. Some still feel the presence of Al Capone in the underground bar he favored at Highgate Manor. The show goes on for the ghost of tap-dancing hero Boots Berry at Stowe’s Green Mountain Inn. Queen City Ghostwalk creator and author Thea Lewis shares chilling encounters and examines the spirits of the past that are not quite resting in peace. <i>Haunted Inns and Ghostly Getaways of Vermont</i> is the only bedtime story for a night in Vermont’s eerie lodgings.<br/>  <br/> Includes photos!<br/>  <br/> “For Lewis, a gifted storyteller, a good story makes a haunted place all the more compelling.” —<i>Happy Vermont</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Thea Lewis
      </h2>
      
      <p class="authorDescription body article">Thea Lewis is the owner and tour guide for Queen City Ghost Walk. She is the author of HAUNTED BURLINGTON (2009). She works for WCAX-TV and is also active in the chamber of commerce in Burlington.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Haunted America
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?ef881bdc